import Header from "./Header";
import Footer from "./Footer";

import "./less/styles.less";

export default { Header, Footer };
